import { forwardRef } from "react";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

import type { IDropdownButtonProps } from "@similarweb/ui-components";
import type { Translatable } from "app/pages/sales-intelligence/types";
import FilterDropdownButton
    from "app/pages/sales-intelligence/common-components/dropdown/FilterDropdownButton/FilterDropdownButton";

type Props = Pick<IDropdownButtonProps, "isOpen" | "disabled" | "hasValue"> & {
    id: string;
    children: ReactNode;
    placeholder?: Readonly<Translatable>;
} & Omit<ComponentPropsWithoutRef<"div">, "children" | "id">;

const SignalFilterDropdownButton = forwardRef<HTMLDivElement, Props>(function SignalFilterDropdownButton(
    props,
    ref,
) {
    const { children, id, isOpen: isActive, disabled, hasValue, placeholder, ...rest } = props;

    return (
        <FilterDropdownButton
            ref={ref}
            isActive={isActive}
            isDisabled={disabled}
            hasValue={hasValue}
            placeholder={placeholder ?? { key: `si.signals.filters.${id}.placeholder` }}
            dataAutomation={`filter-button-${id}`}
            {...rest}
        >
            {children}
        </FilterDropdownButton>
    );
});

export default SignalFilterDropdownButton;
